// Ported verbatim from himitsuconfidential/downstack-practice (header.js).
// Each row is a permutation of 0..n-1 that is reachable by reordering a
// straight sequence using a single hold slot (swap-into-buffer). Used by the
// generator to shuffle a generated piece sequence into any hold-reachable
// order so solving isn't just "play the queue in generation order."

const reverseHold2Table = [
  [0, 1],
  [1, 0],
];

const reverseHold3Table = [
  [0, 1, 2],
  [0, 2, 1],
  [1, 0, 2],
  [2, 0, 1],
];

const reverseHold4Table = [
  [0, 1, 2, 3],
  [0, 1, 3, 2],
  [0, 2, 1, 3],
  [0, 3, 1, 2],
  [1, 0, 2, 3],
  [1, 0, 3, 2],
  [2, 0, 1, 3],
  [3, 0, 1, 2],
];

const reverseHold5Table = [
  [0, 1, 2, 3, 4],
  [0, 1, 2, 4, 3],
  [0, 1, 3, 2, 4],
  [0, 1, 4, 2, 3],
  [0, 2, 1, 3, 4],
  [0, 2, 1, 4, 3],
  [0, 3, 1, 2, 4],
  [0, 4, 1, 2, 3],
  [1, 0, 2, 3, 4],
  [1, 0, 2, 4, 3],
  [1, 0, 3, 2, 4],
  [1, 0, 4, 2, 3],
  [2, 0, 1, 3, 4],
  [2, 0, 1, 4, 3],
  [3, 0, 1, 2, 4],
  [4, 0, 1, 2, 3],
];

const reverseHold6Table = [
  [0, 1, 2, 3, 4, 5],
  [0, 1, 2, 3, 5, 4],
  [0, 1, 2, 4, 3, 5],
  [0, 1, 2, 5, 3, 4],
  [0, 1, 3, 2, 4, 5],
  [0, 1, 3, 2, 5, 4],
  [0, 1, 4, 2, 3, 5],
  [0, 1, 5, 2, 3, 4],
  [0, 2, 1, 3, 4, 5],
  [0, 2, 1, 3, 5, 4],
  [0, 2, 1, 4, 3, 5],
  [0, 2, 1, 5, 3, 4],
  [0, 3, 1, 2, 4, 5],
  [0, 3, 1, 2, 5, 4],
  [0, 4, 1, 2, 3, 5],
  [0, 5, 1, 2, 3, 4],
  [1, 0, 2, 3, 4, 5],
  [1, 0, 2, 3, 5, 4],
  [1, 0, 2, 4, 3, 5],
  [1, 0, 2, 5, 3, 4],
  [1, 0, 3, 2, 4, 5],
  [1, 0, 3, 2, 5, 4],
  [1, 0, 4, 2, 3, 5],
  [1, 0, 5, 2, 3, 4],
  [2, 0, 1, 3, 4, 5],
  [2, 0, 1, 3, 5, 4],
  [2, 0, 1, 4, 3, 5],
  [2, 0, 1, 5, 3, 4],
  [3, 0, 1, 2, 4, 5],
  [3, 0, 1, 2, 5, 4],
  [4, 0, 1, 2, 3, 5],
  [5, 0, 1, 2, 3, 4],
];

const reverseHold7Table = [
  [0, 1, 2, 3, 4, 5, 6],
  [0, 1, 2, 3, 4, 6, 5],
  [0, 1, 2, 3, 5, 4, 6],
  [0, 1, 2, 3, 6, 4, 5],
  [0, 1, 2, 4, 3, 5, 6],
  [0, 1, 2, 4, 3, 6, 5],
  [0, 1, 2, 5, 3, 4, 6],
  [0, 1, 2, 6, 3, 4, 5],
  [0, 1, 3, 2, 4, 5, 6],
  [0, 1, 3, 2, 4, 6, 5],
  [0, 1, 3, 2, 5, 4, 6],
  [0, 1, 3, 2, 6, 4, 5],
  [0, 1, 4, 2, 3, 5, 6],
  [0, 1, 4, 2, 3, 6, 5],
  [0, 1, 5, 2, 3, 4, 6],
  [0, 1, 6, 2, 3, 4, 5],
  [0, 2, 1, 3, 4, 5, 6],
  [0, 2, 1, 3, 4, 6, 5],
  [0, 2, 1, 3, 5, 4, 6],
  [0, 2, 1, 3, 6, 4, 5],
  [0, 2, 1, 4, 3, 5, 6],
  [0, 2, 1, 4, 3, 6, 5],
  [0, 2, 1, 5, 3, 4, 6],
  [0, 2, 1, 6, 3, 4, 5],
  [0, 3, 1, 2, 4, 5, 6],
  [0, 3, 1, 2, 4, 6, 5],
  [0, 3, 1, 2, 5, 4, 6],
  [0, 3, 1, 2, 6, 4, 5],
  [0, 4, 1, 2, 3, 5, 6],
  [0, 4, 1, 2, 3, 6, 5],
  [0, 5, 1, 2, 3, 4, 6],
  [0, 6, 1, 2, 3, 4, 5],
  [1, 0, 2, 3, 4, 5, 6],
  [1, 0, 2, 3, 4, 6, 5],
  [1, 0, 2, 3, 5, 4, 6],
  [1, 0, 2, 3, 6, 4, 5],
  [1, 0, 2, 4, 3, 5, 6],
  [1, 0, 2, 4, 3, 6, 5],
  [1, 0, 2, 5, 3, 4, 6],
  [1, 0, 2, 6, 3, 4, 5],
  [1, 0, 3, 2, 4, 5, 6],
  [1, 0, 3, 2, 4, 6, 5],
  [1, 0, 3, 2, 5, 4, 6],
  [1, 0, 3, 2, 6, 4, 5],
  [1, 0, 4, 2, 3, 5, 6],
  [1, 0, 4, 2, 3, 6, 5],
  [1, 0, 5, 2, 3, 4, 6],
  [1, 0, 6, 2, 3, 4, 5],
  [2, 0, 1, 3, 4, 5, 6],
  [2, 0, 1, 3, 4, 6, 5],
  [2, 0, 1, 3, 5, 4, 6],
  [2, 0, 1, 3, 6, 4, 5],
  [2, 0, 1, 4, 3, 5, 6],
  [2, 0, 1, 4, 3, 6, 5],
  [2, 0, 1, 5, 3, 4, 6],
  [2, 0, 1, 6, 3, 4, 5],
  [3, 0, 1, 2, 4, 5, 6],
  [3, 0, 1, 2, 4, 6, 5],
  [3, 0, 1, 2, 5, 4, 6],
  [3, 0, 1, 2, 6, 4, 5],
  [4, 0, 1, 2, 3, 5, 6],
  [4, 0, 1, 2, 3, 6, 5],
  [5, 0, 1, 2, 3, 4, 6],
  [6, 0, 1, 2, 3, 4, 5],
];

export const REVERSE_HOLD_TABLE: Record<number, number[][]> = {
  2: reverseHold2Table,
  3: reverseHold3Table,
  4: reverseHold4Table,
  5: reverseHold5Table,
  6: reverseHold6Table,
  7: reverseHold7Table,
};
